import styled from "styled-components";

const StyledNewBadge = styled.div`
  position: absolute;
  bottom: ${({ bottomPixel }) => bottomPixel};
  background: #ee3123;
  color: white;
  padding: 2px 6px;
  font-size: 0.6rem;
  border-bottom-right-radius: 8px;
  z-index: ${({ showBizTripTutorial }) => (showBizTripTutorial ? 99 : 1)};
`;

const NewBadge = ({ bottomPixel, showBizTripTutorial }) => (
  <StyledNewBadge
    bottomPixel={bottomPixel}
    showBizTripTutorial={showBizTripTutorial}
  >
    NEW
  </StyledNewBadge>
);

export default NewBadge;
